module.exports = __webpack_public_path__ + "img/222.d779da17.png";